export const SET_TO_BE_UPLOADED_CSV = "SET_TO_BE_UPLOADED_CSV";
export const TOGGLE_TO_BE_REFLECTED_ALL_FACILITIES =
  "TOGGLE_TO_BE_REFLECTED_ALL_FACILITIES";
export const TOGGLE_UPLOAD_SUCCEEDED = "TOGGLE_UPLOAD_SUCCEEDED";
export const RESET_CSV_STATE = "RESET_CSV_STATE";
export const CSV_UPLOAD_REQUESTED = "CSV_UPLOAD_REQUESTED";
export const CSV_UPLOAD_SUCCEEDED = "CSV_UPLOAD_SUCCEEDED";
export const CSV_UPLOAD_FAILED = "CSV_UPLOAD_FAILED";
export const SET_TARGET_YEAR = "SET_TARGET_YEAR";
